export default "__VITE_ASSET__3adeb9b7__"